export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_06.f46eca50.jpg";